const isOnDemand = () => {
  // if (typeof window !== "undefined") {
  //   const params = qs.parse(window.location.search)
  //   return (
  //     window.location.pathname.includes(process.env.GATSBY_ON_DEMAND_SLUG) ||
  //     typeof params.on_demand_space !== "undefined"
  //   )
  // }
  return false
}

export default isOnDemand
